import styles from './switch.module.css'

import React from 'react';
import { Asterisk } from "@phosphor-icons/react";
import { Switch as KendoSwitch } from "@progress/kendo-react-inputs";
import { isNullOrEmpty, isObjectNull } from '../helpers/ObjectHelpers';
import { getDisabledStyle } from '../helpers/ElementHelpers';

function Switch({
    onLabel = "",
    offLabel = "",
    checked = false,
    disabled = false,
    isDirty = false,
    onChange,
    size = "large",
    bold = true,
    fontSize = 18,
    autoFontSize = true
}) {

    return (
        <div className={styles.switchContainer}>
            <div>
                <KendoSwitch
                    size={size}
                    onChange={handleOnChange}
                    checked={checked}
                    disabled={disabled}
                    onLabel={null}
                    offLabel={null}
                />
            </div>
            <div style={getStyle(disabled)} className={`${autoFontSize ? "font-size-xl" : ""}`}>
                {checked ? getOnLabel() : getOffLabel()}
            </div>
            <div>
                {
                    isDirty &&
                    <Asterisk color="var(--card-dirty-color)" />
                }
            </div>
        </div>
    );

    function handleOnChange(e) {
        if (disabled || isObjectNull(onChange)) return;

        onChange(e);
    }

    function getOnLabel() {
        if (!isNullOrEmpty(onLabel)) return onLabel;

        return "Ja";
    }

    function getOffLabel() {
        if (!isNullOrEmpty(offLabel)) return offLabel;
        if (!isNullOrEmpty(onLabel)) return onLabel;

        return "Nei";
    }

    function getStyle() {
        const style = getDisabledStyle(disabled);
        if (bold) {
            style.fontWeight = "700";
        }
        style.fontSize = `${fontSize}px`
        return style;
    }
}

export default Switch; 
